import * as t from 'io-ts';
import { isNotNullable } from '@bayer-int/portletce-shared';

import type { MultiSelectDefinition } from 'header/types';

import { createSpecSettingsInterface, define } from './_common';
import { SCALE_OPTIONS } from './scaleSetting';

export interface ScaleValuesSettingDefinition extends MultiSelectDefinition {
    key: 'SCALE_VALUES';
}

const definition: ScaleValuesSettingDefinition = {
    key: 'SCALE_VALUES',
    type: 'MultiSelect',
    label: 'Scale values',
    options: [...SCALE_OPTIONS],
    value: [],
    scope: 'designer',
};

const specSettingsInterface = createSpecSettingsInterface(
    definition,
    t.array(
        t.union([
            t.literal(SCALE_OPTIONS[0].label),
            t.literal(SCALE_OPTIONS[1].label),
            t.literal(SCALE_OPTIONS[2].label),
            t.literal(SCALE_OPTIONS[3].label),
            t.literal(SCALE_OPTIONS[4].label),
        ]),
    ),
);

export const codec = specSettingsInterface.input;

export const ScaleValuesSettingDefinition = define({
    key: 'SCALE_VALUES',
    label: 'ScaleValues',
    definition,
    fromSetting: settings => {
        const scaleLabelsToSelect = specSettingsInterface.extractValue(settings.scaleValues);
        if (!scaleLabelsToSelect) return undefined;

        const selectedKeys = scaleLabelsToSelect
            .map(scaleLabel => SCALE_OPTIONS.find(option => option.label === scaleLabel)?.key)
            .filter(isNotNullable);
        return selectedKeys;
    },
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings => {
        const definition = specSettingsInterface.createDefinitionWithSettings(settings.scaleValues);

        if (!definition) return undefined;

        const options = definition.options.map(item => ({
            key: item.key,
            label: `${item.label} [${item.key}]`,
        }));

        return {
            ...definition,
            options,
        };
    },
});
